import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useStripeOnboard } from '../../APIs/Stripe/stripeConnect';
import './stripeConnectBanner.css';

const STRIPE_ICON = (
  <svg viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="36" cy="36" r="36" fill="#635BFF" fillOpacity="0.12" />
    <path
      d="M36 19C26.611 19 19 26.611 19 36C19 45.389 26.611 53 36 53C45.389 53 53 45.389 53 36C53 26.611 45.389 19 36 19ZM34 43.5L27.5 37L29.321 35.179L34 39.858L42.679 31.179L44.5 33L34 43.5Z"
      fill="#635BFF"
    />
  </svg>
);

const COPY = {
  login: {
    title: 'Connect Your Bank Account',
    desc: 'To accept payments for gift cards and tickets, connect your bank account via Stripe. It only takes a few minutes.',
    btn: 'Connect with Stripe',
    skip: 'Remind me later'
  },
  giftcard: {
    title: 'Payment Setup Required',
    desc: 'Connect your bank account with Stripe before creating gift cards so customers can purchase them.',
    btn: 'Connect with Stripe',
    skip: 'Go Back'
  },
  event: {
    title: 'Payment Setup Required',
    desc: 'Connect your bank account with Stripe before publishing ticketed events so customers can buy tickets.',
    btn: 'Connect with Stripe',
    skip: 'Go Back'
  },
  pass: {
    title: 'Payment Setup Required',
    desc: 'Connect your bank account with Stripe before creating a public pass so customers can purchase it.',
    btn: 'Connect with Stripe',
    skip: 'Go Back'
  }
};

export default function StripeConnectBanner({ show, onHide, context = 'login' }) {
  const { startOnboarding } = useStripeOnboard();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const copy = COPY[context] || COPY.login;

  const handleConnect = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await startOnboarding();
      if (res?.onboarding_url) {
        window.location.href = res.onboarding_url;
      } else {
        setError(res?.message || 'Could not start Stripe onboarding. Please try again.');
        setLoading(false);
      }
    } catch {
      setError('Something went wrong. Please try again.');
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide || undefined}
      backdrop={onHide ? true : 'static'}
      keyboard={!!onHide}
      centered
      className="stripe-connect-modal"
    >
      <Modal.Body className="stripe-connect-body">
        <div className="sc-stripe-icon">{STRIPE_ICON}</div>
        <h4 className="sc-title">{copy.title}</h4>
        <p className="sc-desc">{copy.desc}</p>

        {error && (
          <div className="alert alert-danger py-2 px-3 mb-3" style={{ fontSize: '13px', textAlign: 'left' }}>
            {error}
          </div>
        )}

        <div className="sc-actions">
          <button className="sc-btn-primary btn" onClick={handleConnect} disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" />
                Redirecting…
              </>
            ) : (
              copy.btn
            )}
          </button>
          {onHide && (
            <button className="sc-btn-skip" onClick={onHide}>
              {copy.skip}
            </button>
          )}
        </div>

        <p className="sc-note">You'll be taken to Stripe's secure onboarding page.</p>
      </Modal.Body>
    </Modal>
  );
}
